

export const GETDATAWOMENLOADING ="GETDATAWOMENLOADING";
export const GETDATAWOMENSUCCESS = "GETDATAWOMENSUCCESS";
export const GETDATAWOMENERROR = "GETDATAWOMENERROR" 